@if (currentTemplate === 'OVERZICHT' && overzichtTemplateSettings; as settings) {
    <mijn-overzicht-template
        [title]="settings.title"
        [tabTitle]="formatTabTitle(settings.tabTitle)"
        [breadcrumb]="settings.breadcrumb"
        [subtitle]="settings.subtitle"
        [secondarySubtitle]="settings.secondarySubtitle"
        [amount]="settings.amount"
        [amountVariant]="settings.amountVariant"
        [amountContrast]="settings.amountContrast"
        [secondarySubAmount]="settings.secondarySubAmount"
        [primaryActionLabel]="settings.primaryActionLabel"
        [secondaryActionLabel]="settings.secondaryActionLabel"
        [variant]="settings.variant"
        [loading]="settings.loading"
        [avatar]="settings.avatar"
        [changeConversationalStatus$]="settings.changeConversationalStatus"
        [updateURL]="settings.updateURL"
        [feedbackConfiguration]="settings.feedbackConfiguration"
        [updateUnreadMessages$]="settings.updateUnreadMessages$"
        [updatePendingActions$]="settings.updatePendingActions$"
        (primaryActionClicked)="primaryActionClicked()"
        (secondaryActionClicked)="secondaryActionClicked()"
        (chatNotificationSent)="chatNotificationSent($event)"
    >
    </mijn-overzicht-template>
}
@if (currentTemplate === 'ACTIE' && actieTemplateSettings; as settings) {
    <mijn-actie-template
        [title]="settings.title"
        [tabTitle]="formatTabTitle(settings.tabTitle)"
        [subtitle]="settings.subtitle"
        [fullWidth]="settings.fullWidth"
        [dynamicRouting]="settings.dynamicRouting"
        [changeConversationalStatus$]="settings.changeConversationalStatus"
        [contextHelp]="settings.contextHelp"
        (closeTemplate)="closeTemplate()"
    >
    </mijn-actie-template>
}

<div
    [ngClass]="{
        'canvas-mobile': currentTemplate === 'MOBILE',
        'mijn-overzicht-template__content canvas-medium': currentTemplate === 'OVERZICHT',
        'mijn-actie-template__body canvas-small': currentTemplate === 'ACTIE' && !actieTemplateSettings.fullWidth,
        'mijn-actie-template__body canvas-full': currentTemplate === 'ACTIE' && actieTemplateSettings.fullWidth
    }"
>
    <main id="main-content">
        <router-outlet></router-outlet>
    </main>
</div>
